<div class="content height-800">
  <div class="layout-auto-1-auto ">
    <!-- Search Header -->
    <exg-search-bar (Search)="homeSummaryData.ablaufplan.search($event)"
                    [placeholder]="getRessource('ListAblaufplanSearchHolder')"
                    class="span-layout">
      <ng-template #rightTemplate>
        <app-exg-dropdown  style="max-height: calc(100VH - 30rem )">
          <ng-template #hostTemplate>
            <i class="search-action fal fa-filter"
               [class.fas]="homeSummaryData.ablaufplan.uiFilterAktiv(1).length > 0"
               [class.fal]="homeSummaryData.ablaufplan.uiFilterAktiv(1).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCAblaufplanListFilterControl
                            (onActivateFilter)="homeSummaryData.ablaufplan.pageChanged(1);popup.close()"
                            [MetaInfo]="homeSummaryData.ablaufplan.MetaInfo"
                            [showFilter]="true" [uiFilter]="homeSummaryData.ablaufplan.uiFilter"
                            [visibility]="popup.visibility !== 'hidden'" [containerClass]="'app-filter-home'"
                            [uiSort]="homeSummaryData.ablaufplan.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fal fa-sort-alt"
               [class.fas]="homeSummaryData.ablaufplan.uiSortAktiv().length > 0"
               [class.fal]="homeSummaryData.ablaufplan.uiSortAktiv().length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCAblaufplanListSortControl
                            (onActivateFilter)="homeSummaryData.ablaufplan.pageChanged(1);popup.close()"
                            [MetaInfo]="homeSummaryData.ablaufplan.MetaInfo"
                            [showSort]="true" [uiFilter]="homeSummaryData.ablaufplan.uiFilter"
                            [visibility]="popup.visibility !== 'hidden'" [containerClass]="'app-filter-home'"
                            [uiSort]="homeSummaryData.ablaufplan.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-binoculars"
               [class.fas]="homeSummaryData.ablaufplan.uiFilterAktiv(2).length > 0"
               [class.fal]="homeSummaryData.ablaufplan.uiFilterAktiv(2).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCAblaufplanListSearchControl
                            (onActivateFilter)="homeSummaryData.ablaufplan.pageChanged(1);popup.close()"
                            [MetaInfo]="homeSummaryData.ablaufplan.MetaInfo"
                            [showSearch]="true" [uiFilter]="homeSummaryData.ablaufplan.uiFilter"
                            [visibility]="popup.visibility !== 'hidden'" [containerClass]="'app-filter-home'"
                            [uiSort]="homeSummaryData.ablaufplan.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
      </ng-template>
    </exg-search-bar>
    <div class="content ">
      <exg-data-list #VCAblaufplanItemList
                     (RowChange)="homeSummaryData.ablaufplan.selectionChanged($event)"
                     (RowDblClick)="onDblClickTaskCheckView($event)"
                     [allowSingleSelection]="true"
                     [displayState]="homeSummaryData.ablaufplan.state"
                     [rowSource]="homeSummaryData.ablaufplan.items"
                     [selectKey]="homeSummaryData.ablaufplan.selectedKey"
                     [selectSource]="homeSummaryData.ablaufplan.selectedRow"
                     class="list">
        <ng-template #rowTemplate let-apItem>
          <div class="list-row list-row-auto-1 app-list">
            <div [class.c-blue]="apItem.DateDiffSoll_PlanDate > 0"
                 [class.c-orange]="apItem.DateDiffSoll_PlanDate === 0"
                 [class.c-red]="apItem.DateDiffSoll_PlanDate < 0"
                 class="typo-center">
              <div class="typo-center">
                <i class="fa-xl fa-regular fa-calendar-lines"
                   *ngIf="apItem.DateDiffSoll_PlanDate > 0 ">
                </i>
                <i class="fa-xl fa-regular fa-calendar-day"
                   *ngIf="apItem.DateDiffSoll_PlanDate === 0 ">
                </i>
                <i class="fa-xl fa-regular fa-calendar-exclamation"
                   *ngIf="apItem.DateDiffSoll_PlanDate < 0 ">
                </i>
              </div>
              <div class="typo-small app-space-top">
                {{
                  apItem.DateDiffSoll_PlanDate === 0 ? 'Heute' :
                  apItem.DateDiffSoll_PlanDate > 0 ? 'in ' + apItem.DateDiffSoll_PlanDate + ' T.' :
                  apItem.DateDiffSoll_PlanDate < 0 ? 'vor ' + apItem.DateDiffSoll_PlanDate + ' T.' : ''
                }}
              </div>
            </div>
            <div class="typo-small">
              <div class="grid-1-auto">
                <div class="typo-container-s-s-q">
                  <span>
                    <strong>{{apItem.vorgNr}}</strong>
                  </span>
                  <span>
	                  {{enumSvc.getEnumerationText('VorgangStatus', apItem.vorg_enmIdent_VorgangStatus)}}
                  </span>
                  <q></q>
                </div>
                <div class="list-metadata ">
                  <div class="typo-right">{{apItem.apiLCU ? apItem.apiLCU : apItem.apiCRU}}</div>
                  <div
                    class="typo-right">{{(apItem.apiLCD ? apItem.apiLCD : apItem.apiCRD) | excDate: 'dd.MM.yy HH:mm'}}</div>
                </div>
              </div>
              <div class="grid-1-auto">
                <div class="typo-container-s-s-q span-2 app-typo-tablecell app-space-top">
                  <span>
                    {{enumSvc.getFieldCaption("AuftragE_EIS", 'aueVersicherungsnehmer')}}
                  </span>
                  <span>{{apItem.Versicherungsnehmer}}</span>
                  <q></q>
                  <ng-container *ngIf="apItem.auAuftraggeberShort || apItem.aue_enmIdent_Versicherungsart !== null || apItem.aue_enmIdent_SchadenArt !== null">
                    <span>
                      {{ getRessource('Insurance') }}
                    </span>
                    <span>
                      {{ apItem.auAuftraggeberShort || '-' }}
                      <ng-container *ngIf="apItem.aue_enmIdent_Versicherungsart">
                        | {{ enumSvc.getEnumerationText('Versicherungsart', apItem.aue_enmIdent_Versicherungsart) }}
                      </ng-container>
                      <ng-container *ngIf="apItem.aue_enmIdent_SchadenArt">
                        | {{ enumSvc.getEnumerationText('Schadenart', apItem.aue_enmIdent_SchadenArt) }}
                      </ng-container>
                    </span>
                    <q></q>
                  </ng-container>
                  <span>
                    {{enumSvc.getFieldCaption("AuftragE_EIS", 'aueSchadenOrt')}}
                  </span>
                  <span>
                    {{apItem.aueSchadenOrt}}
                  </span>
                  <q></q>
                  <ng-container *ngIf="apItem.apiBezeichnung && apItem?.apiBezeichnung.length > 0">
                    <span>
                      {{enumSvc.getFieldCaption("Ablaufplan", 'apiBezeichnung')}}
                    </span>
                    <span>{{apItem.apiBezeichnung}}</span>
                    <q></q>
                  </ng-container>
                  <ng-container *ngIf="apItem.apiKommentar">
                    <span>
                      {{ enumSvc.getFieldCaption("Ablaufplan", 'apiKommentar') }}
                    </span>
                    <span
                      [style.display]="'block'"
                      [style.white-space]="homeSummaryData.ablaufplan.selectedRow === apItem ? 'normal' : 'nowrap'"
                      [style.overflow]="homeSummaryData.ablaufplan.selectedRow === apItem  ? 'visible' : 'hidden'"
                      [style.text-overflow]="homeSummaryData.ablaufplan.selectedRow === apItem  ? 'clip' : 'ellipsis'">
                      {{apItem.apiKommentar}}
                    </span>
                    <q></q>
                  </ng-container>
                  <ng-container *ngIf="apItem.DateDiffSoll_PlanDate < 0">
                  <span [class.c-blue]="apItem.DateDiffSollDate > 0"
                        [class.c-orange]="apItem.DateDiffSoll_PlanDate === 0"
                        [class.c-red]="apItem.DateDiffSoll_PlanDate < 0">
                          {{enumSvc.getFieldCaption("Ablaufplan", 'apiSollDatum')}}
                    </span>
                    <span [class.c-blue]="apItem.DateDiffSollDate > 0"
                          [class.c-orange]="apItem.DateDiffSoll_PlanDate === 0"
                          [class.c-red]="apItem.DateDiffSoll_PlanDate < 0">
                        {{apItem.apiSollDatum | excDate: 'dd.MM.yyyy HH:mm'}}
                    </span>
                    <q></q>
                  </ng-container>
                  <span [class.c-blue]="apItem.DateDiffSoll_PlanDate > 0"
                        [class.c-orange]="apItem.DateDiffSoll_PlanDate === 0"
                        [class.c-red]="apItem.DateDiffSoll_PlanDate < 0">
                        {{enumSvc.getFieldCaption("Ablaufplan", 'apiPlanDatum')}}
                  </span>
                  <span [class.c-blue]="apItem.DateDiffSoll_PlanDate > 0"
                        [class.c-orange]="apItem.DateDiffSoll_PlanDate === 0"
                        [class.c-red]="apItem.DateDiffSoll_PlanDate < 0">
                      {{apItem.apiPlanDatum | excDate: 'dd.MM.yyyy HH:mm'}}
                  </span>
                  <q></q>
                </div>
                <div class="typo-center">
                  <i class="search-action fa-regular fa-chevron-right"
                     *ngIf="homeSummaryData.ablaufplan.selectedRow === apItem"
                     (click)="onClickOpenTaskCheckview(apItem.vorgID)">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </exg-data-list>
    </div>
    <exg-pager  class="span-layout"
                (PageChange)="homeSummaryData.ablaufplan.pageChanged($event)"
                [pagingSource]="homeSummaryData.ablaufplan.paging">
<!--       <ng-template #rightTemplate> -->
<!--         <div class="app-pager-chips"> -->
<!--           <app-exg-filter-chips #VCFilterChips -->
<!--                                 [inputDataTable]="homeSummaryData.ablaufplan" -->
<!--                                 [VCFilterControl]="{ -->
<!--                                     VCFilter: VCAblaufplanListFilterControl, -->
<!--                                     VCSearch: VCAblaufplanListSearchControl, -->
<!--                                     VCSort: VCAblaufplanListSortControl}"> -->
<!--           </app-exg-filter-chips> -->
<!--         </div> -->
<!--       </ng-template> -->
    </exg-pager>
  </div>
</div>
